import { routes } from 'config/routes'
import { useTranslation } from 'libs/i18n'

import { CtaLink } from 'shared/components'

const ErrorPage = () => {
	const { t } = useTranslation()

	return (
		<div className="flex h-screen w-full items-center justify-center px-4">
			<div className="text-center">
				<h1 className="text-8xl font-semibold text-tundora">404</h1>
				<p className="text-2xl text-doveGray">
					{t(`Sorry, the page you're looking for doesn't exist.`)}
				</p>
				<CtaLink
					className="mx-auto mt-6 max-w-[185px]"
					to={routes.dashboard}
					text={t('Return home')}
					icon={false}
				/>
			</div>
		</div>
	)
}

export default ErrorPage
